import React from "react";

export const AboutCompany = () => {
 return (
 <div className="space-y-6">
 <div className="bg-white p-6 rounded-lg shadow-md">
 <h2 className="text-2xl font-bold text-gray-900 mb-4">О компании</h2>
 
 <div className="prose max-w-none">
 <div className="mb-6">
 <h3 className="text-xl font-semibold text-gray-800 mb-3">Администрация платформы</h3>
 <p className="text-sm text-gray-500 mb-3">Редакция от 4 августа 2026 года</p>
 
 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
 <div className="space-y-3">
 <div>
 <span className="font-medium text-gray-700">Полное имя:</span>
 <p className="text-gray-600">Сумченко О.А.</p>
 </div>
 
 <div>
 <span className="font-medium text-gray-700">ИНН:</span>
 <p className="text-gray-600 font-mono">230808284051</p>
 </div>
 
 <div>
 <span className="font-medium text-gray-700">Регион деятельности:</span>
 <p className="text-gray-600">Краснодарский край, Российская Федерация</p>
 </div>
 </div>
 
 <div className="space-y-3">
 <div>
 <span className="font-medium text-gray-700">Электронная почта:</span>
 <p className="text-gray-600">
 <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru
 </a>
 </p>
 </div>
 
 <div>
 <span className="font-medium text-gray-700">Режим работы:</span>
 <p className="text-gray-600">Пн-Пт: 9:00-18:00 (МСК)</p>
 </div>
 
 <div>
 <span className="font-medium text-gray-700">Веб-сайт:</span>
 <p className="text-gray-600">
 <a href="https://reversia.ru" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">reversia.ru
 </a>
 </p>
 </div>
 
 <div>
 <span className="font-medium text-gray-700">Дата начала деятельности:</span>
 <p className="text-gray-600">2025 год</p>
 </div>
 </div>
 </div>
 </div>
 
 <div className="border-t pt-6">
 <h4 className="text-lg font-semibold text-gray-800 mb-3">О платформе Reversia</h4>
 <p className="text-gray-700 leading-relaxed mb-4">
 <strong>Reversia</strong> — цифровая платформа для заказа фото-/видеосъемки и выполнения локальных заданий. 
 Мы соединяем заказчиков с квалифицированными исполнителями (ИП и самозанятыми) по всей России, 
 обеспечивая безопасные сделки через платежную систему YuKassa и систему гарантий качества.
 </p>
 
 <div className="bg-blue-50 p-4 rounded-lg mb-4">
 <h5 className="font-semibold text-blue-800 mb-2">Наша миссия</h5>
 <p className="text-blue-700 text-sm">Сделать качественные фото/видео услуги доступными в любой точке России, 
 поддерживая предпринимателей и обеспечивая прозрачные отношения между всеми участниками.
 </p>
 </div>
 
 <div className="mt-4">
 <h5 className="font-medium text-gray-800 mb-3">Основные услуги платформы:</h5>
 <div className="grid md:grid-cols-2 gap-4">
 <div className="space-y-2">
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Фото/видеосъемка мероприятий</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Проверка недвижимости</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Тайный покупатель</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Мемориальный сервис</span>
 </div>
 </div>
 <div className="space-y-2">
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Мобильная журналистика</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Локальные исследования</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Геолокационные задания</span>
 </div>
 <div className="flex items-start space-x-2">
 <span className="text-gray-700">Контроль качества услуг</span>
 </div>
 </div>
 </div>
 </div>
 
 <div className="mt-6 bg-gray-50 p-4 rounded-lg">
 <h5 className="font-semibold text-gray-800 mb-2">Гарантии безопасности</h5>
 <ul className="list-disc list-inside text-gray-700 space-y-1 text-sm">
 <li>Регистрация исполнителей с указанием контактных данных</li>
 <li>Верификация личности исполнителей по паспорту (ручная проверка администрацией): для заданий с доступом к жилью и личным вещам допускаются только проверенные исполнители</li>
 <li>Система безопасных платежей YuKassa: средства, внесенные заказчиком, поступают на платформу и удерживаются до подтверждения выполнения задания исполнителем</li>
 <li>Система споров с независимым рассмотрением конфликтов</li>
 <li>Возврат средств при нарушении условий или невыполнении заданий: заказчик может подать претензию через форму в приложении, администратор рассматривает доказательства и принимает решение о возврате</li>
 <li>Система рейтингов и отзывов для оценки исполнителей</li>
 <li>Техническая поддержка при возникновении проблем</li>
 </ul>
 </div>
 
 <div className="mt-6 bg-green-50 p-4 rounded-lg">
 <h5 className="font-semibold text-green-800 mb-2">Для самозанятых исполнителей</h5>
 <p className="text-green-700 text-sm mb-2">Платформа полностью адаптирована под требования налогового режима НПД:
 </p>
 <ul className="list-disc list-inside text-green-700 space-y-1 text-sm">
 <li>Комиссия платформы: 10% (для специальных услуг 15-25%)</li>
 <li>Оперативные выплаты в течение 24 часов после подтверждения выполнения задания</li>
 <li>Информационная поддержка по вопросам налогообложения для самозанятых</li>
 <li>Все расчеты осуществляются в соответствии с действующим законодательством</li>
 </ul>
 </div>
 </div>
 
 <div className="border-t pt-6">
 <h4 className="text-lg font-semibold text-gray-800 mb-3">Контактная информация</h4>
 <div className="bg-blue-50 p-4 rounded-lg">
 <div className="grid md:grid-cols-2 gap-4 text-sm">
 <div>
 <p><strong>Техническая поддержка:</strong></p>
 <p>Email: <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru</a></p>
 <p>Время ответа: в течение 24 часов</p>
 </div>
 <div>
 <p><strong>Правовые вопросы:</strong></p>
 <p>Email: <a href="mailto:support@reversia.ru?subject=Правовой%20вопрос" className="text-blue-600 hover:underline">support@reversia.ru</a></p>
 <p>Время ответа: до 3 рабочих дней</p>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
};

